import * as _actions from './actions';
import _reducer from './reducer';

export const reducer = _reducer;
export const actions = _actions;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/StudyPlan/index.js